export const LOAD_SERVICES = "LOAD_SERVICES";
export const SET_SERVICE_LOADING = "SET_SERVICE_LOADING";
export const LOAD_SUB_SERVICES = "LOAD_SUB_SERVICES";
